import React, { useContext } from 'react';
import cls from 'classnames';
import NormalLogoSvg from '@/static/images/merchant/logo_header.svg'; // TODO: 需要新增 ID logo

import IDLogoSvg from '@/static/images/merchant/id_logo_header.svg';
import Anchor from '../Anchor';
import styles from './index.module.scss';
import { BaseContext } from '@/contexts/BaseContext';

const Logo = ({
  className,
  href
}) => {
  const {
    isIdRegion
  } = useContext(BaseContext);
  const LogoSvg = isIdRegion ? IDLogoSvg : NormalLogoSvg;
  return /*#__PURE__*/React.createElement(Anchor, {
    href: href || 'javascript:;',
    className: styles.logoContainer
  }, /*#__PURE__*/React.createElement(LogoSvg, {
    className: cls(styles.logo, className)
  }));
};

export default Logo;